<template>
  <div class="timeline-item-content">
    <div class="timeline-item-content__main-block">
      <template v-if="data.date || data.author || hasHeader">
        <slot name="header">
          <div class="timeline-item-content__header-row">
            <p
              v-if="data.date"
              class="timeline-item-content__text"
            >
              {{ data.date }}
            </p>
            <template v-if="data.author">
              <div class="timeline-item-content__dot" />
              <p class="timeline-item-content__text">
                {{ data.author }}
              </p>
            </template>
          </div>
        </slot>
      </template>
      <template v-if="data.text || hasText">
        <slot name="text">
          <p class="timeline-item-content__title">
            {{ data.text }}
          </p>
        </slot>
      </template>
      <div
        v-if="data.comment"
        class="timeline-item-content__comment"
      >
        <p class="timeline-item-content__comment-text">
          {{ data.comment }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  PropType,
} from 'vue';

import { TTimelineItem } from '@/ui/experimental/Timeline/types';
import { hasSlotContent } from '@/utils/hasSlotContent';

export default defineComponent({
  name: 'TimelineItemContent',
  props: {
    data: {
      type: Object as PropType<TTimelineItem>,
      required: true,
    },
    withLine: {
      type: Boolean,
      default: true,
    },
  },
  setup(_, { slots }) {
    const hasText = computed(() => hasSlotContent({
      slots,
      slotName: 'text',
    }));

    const hasHeader = computed(() => hasSlotContent({
      slots,
      slotName: 'header',
    }));

    return {
      hasText,
      hasHeader,
    };
  },
});
</script>

<style lang="scss" src="./styles.scss" />
